<ng-container *ngIf="isCookieBannerShown$ | async">
  <div class="cookie-banner py-4 shadow no-print">
    <div class="container">
      <div class="row">
        <div class="col">
          <h2>{{ 'CookieBanner.Header' | tekstresource }}</h2>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <p>
            {{ 'CookieBanner.InfoText' | tekstresource }}<br />
            <a [routerLink]="['/hjaelp/myndighedsinformation/', 'cookiepolitik']">{{
              'CookieBanner.ReadMore' | tekstresource
            }}</a>
          </p>
        </div>

        <div class="col col-auto px-4 py-3">
          <button class="button button-tertiary" (click)="setCookieAcceptCookiesValue()">
            {{ 'CookieBanner.AcceptCookies' | tekstresource }}
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-container>
